import React from 'react';
import s from './TwoColumnBlock.module.css';
import EmbeddedVideo from '../../EmbeddedVideo/EmbeddedVideo';
import {
    ButtonBlockProps,
    ButtonBlockValueProps,
    TwoColumnBlockProps,
} from '@/types/components/blocks';
import { ImageData } from '@/types/components/image';
import { EmbeddedVideoProps } from '@/types/components/video';
import { WbTwocolumns } from '@digital-engineering-experiences/wb-webcomponents';
import RawHtml from '@/components/RawHtml';
import EmbeddedImage from '@/components/Image/Image';
import ButtonBlock from '../ButtonBlock';

const TwoColumnBlock = ({ data }: { data: TwoColumnBlockProps }) => {
    const backgroundcolor = data.bgcolor?.backgroundColor || '';

    const renderContent = (content: any) => {
        if (content.type === 'Text') {
            return <RawHtml html={content.value as string} />;
        } else if (content.type === 'Image') {
            return (
                <EmbeddedImage
                    data={content.value as ImageData}
                    imageDetails={(content.value as ImageData).image.img}
                />
            );
        } else if (content.type === 'Video') {
            return (
                <EmbeddedVideo
                    src={(content.value as EmbeddedVideoProps).src}
                    autoPlay={(content.value as EmbeddedVideoProps).autoPlay}
                    controls={(content.value as EmbeddedVideoProps).controls}
                    muted={(content.value as EmbeddedVideoProps).muted}
                />
            );
        } else if (content.type === 'buttons') {
            return (
                <ButtonBlock value={content.value as ButtonBlockValueProps} />
            );
        }
    };

    const renderColumn = (items: any[]) => {
        return (
            <>
                {items.map((item, index) => (
                    <React.Fragment key={index}>
                        {renderContent(item)}
                    </React.Fragment>
                ))}
            </>
        );
    };

    return (
        <div className={backgroundcolor}>
            <div className={s.twocolumnsBlock}>
                <WbTwocolumns
                    inverse={data.columnOrder == 'invert' && true}
                    variant={data.grid}
                    leftcolumn={renderColumn(data.columnLeft)}
                    rightcolumn={renderColumn(data.columnRight)}></WbTwocolumns>
            </div>
        </div>
    );
};

export default TwoColumnBlock;
